export const tabs = {
    main: "#tab=main",
    charts: "#tab=charts",
};
